
import { HiOutlinePhotograph } from "react-icons/hi"
import useQueryDowload from "../../../customHooks/useQueryDowloand"
import { FaRegFilePdf } from "react-icons/fa"

interface Props {
  url: string
  title: string
  id_brand: string
  name: string
  image: string
}
const FlyerRaffle = ({ url, title, id_brand, name, image }: Props) => {
  const { isLoading, onGeneratePost } = useQueryDowload({ name: `${name}.pdf` })

  const onDownloadOne = () => {
    // setIsLoading(true)
    onGeneratePost({url, params: {id_brand}})
  }

  return (
    <div className="c-flyers__container">
      <div className="c-flyers__header">
        <span className="c-flyers__title">{title}</span>
      </div>
      <div className="c-flyers__content" >
        <img src={image} className={`c-flyers__img-qr`} alt="flyer-campaign" />
      </div>
      <button className={`c-flyers__button-download ${isLoading && `c-flyers__button-download--disabled`}`} onClick={onDownloadOne}>
        {
          isLoading ?
            <>
              Download...<div className="spiner"></div>
            </>
            :
            <>
              Download color  <FaRegFilePdf />
            </>
        }
      </button>
    </div>
  )
}
export default FlyerRaffle